import './Logo.scss'
import profileImg from '../../../assets/images/profile.png'

const Logo = () => {
   return (
     <div className="logo-container">
       <img className="profile-portrait" src={profileImg} alt="Anuj Rathore" />
     </div>
   );
}

export default Logo